import React from 'react';
import AddFundPage from '../containers/AddFundsPage';

const AddFunds = () => {
  return (
    <AddFundPage/>
  )
}

export default AddFunds;